export default {
    product:'产品介绍',
    OCR:'OCR',
    Face:"人脸识别",
    Risk:"智能风控",
    zhinengdaoliu:"智能导流",
    BlackList:'黑名单',
    xinyongbaogao: "信用报告",
    useCases:"合作案例",
    News:"新闻热点",
    Company:"公司资讯",
    joinUs:"加入我们",
    aboutUs:"关于我们",
    contactUs:"联系我们",
};
